import React, { Component } from "react";

import { CButton } from "@coreui/react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { toastr } from "react-redux-toastr";
import { bindActionCreators } from "redux";

import { logout } from "../../../actions/baseActions";
import { setLayout } from "../../../actions/layoutActions";
import { setObj } from "../../../actions/noteActions";
import ApplicatedTvQuestionList from "../../../components/ApplicatedTvQuestionList";
import Interface from "../../../components/Interface";
import LiterarteModal from "../../../components/LiterarteModal";
import Loading from "../../../components/Loading";
import ModalTools from "../../../components/ModalTools";
import ProtectedRoute from "../../../components/ProtectedRoute";
import UploadModal from "../../../components/UploadModal";
import URL from "../../../config/api";
import axios from "../../../config/axios";
import { baseDate } from "../../../utils/date";
import { caminhoDoLo } from "../../../utils/loSingleView";

import "./style.css";

const FileDownload = require("js-file-download");

class EvaluationTv extends Component {
  constructor(props) {
    super(props);

    this.state = {
      loading: true,
      activity: null,
      execution_id: null,
      uploadModal: false,
      textProduction: {
        id: "",
        show: false,
        value: [
          {
            type: "paragraph",
            children: [{ text: "" }]
          }
        ]
      },
      literarteStart: null,
      contentName: ""
    };
  }

  error(response) {
    if (response === "Unauthorized") {
      this.props.logout(this.props.user.token);
    } else {
      toastr.error("Falha", response);
    }
  }

  componentDidMount() {
    this.props.setObj(16, this.props.currentRoute, this.props.currentRoute);

    this.handleActivity();
  }

  createExecution(callback = () => null) {
    const obj = {
      activity_id: this.props.match.params.activity_id,
      user_id: this.props.user.user.id
    };

    axios
      .post(`${URL.api}activity/execution/insert`, obj, {
        headers: {
          authorization: `Bearer ${this.props.user.token}`,
          "Access-Control-Allow-Origin": "*"
        }
      })
      .then(resp => {
        if (resp.data.success) {
          this.setState({ execution_id: resp.data.data }, () => callback());
        } else {
          this.error("Falha ao criar a execução da atividade!");
        }
      })
      .catch(error => {
        if (error.response && error.response.status === 401) {
          this.error("Sua sessão expirou!");
          this.props.logout();
        } else {
          this.error("Falha ao criar a execução da atividade!");
        }
      });
  }

  createItemExecution(item, finished, callback = () => null) {
    const late = false;

    if (finished || late) {
      callback();
      return;
    }

    const obj = {
      execution_id: this.state.execution_id,
      item_id: item,
      completion_percentage: 100,
      start: new Date(
        Date.now() - new Date().getTimezoneOffset() * 60 * 1000
      ).toISOString(),
      end: new Date(
        Date.now() - new Date().getTimezoneOffset() * 60 * 1000
      ).toISOString()
    };

    axios
      .post(`${URL.api}activity/execution/item/insert`, obj, {
        headers: {
          authorization: `Bearer ${this.props.user.token}`,
          "Access-Control-Allow-Origin": "*"
        }
      })
      .then(resp => {
        if (resp.data.success) {
          callback();
        } else {
          this.error("Falha ao criar a execução do item!");
        }
      })
      .catch(error => {
        if (error.response && error.response.status === 401) {
          this.error("Sua sessão expirou!");
          this.props.logout();
        } else {
          this.error("Falha ao criar a execução do item!");
        }
      });
  }

  handleActivity(callback = () => null) {
    this.createExecution(() => {
      axios
        .get(
          `${URL.api}activity/activity/singleViewByExecution/${this.state.execution_id}`,
          {
            headers: {
              authorization: `Bearer ${this.props.user.token}`,
              "Access-Control-Allow-Origin": "*"
            }
          }
        )
        .then(resp => {
          if (resp.data.success) {
            const itemId = parseInt(this.props.match.params.list_id);
            const item = resp.data.data.items.find(item => item.id === itemId);

            if (item.type_id === 14) {
              this.setState({
                textProduction: {
                  // eslint-disable-next-line react/no-access-state-in-setstate
                  ...this.state.textProduction,
                  show: true,
                  id: item.obj_id
                },
                // item_id: item.id,
                contentName: item.title,
                literarteStart: new Date()
              });
            }

            if (
              [7, 8, 9].includes(this.props.general.active_roles.role_id) &&
              [24, 15, 16, 27, 17].includes(item.type_id)
            ) {
              this.createItemExecution(itemId, item.item_percentage === 100);
            }

            this.setState({
              activity: resp.data.data,
              loading: false
            });
          } else {
            this.error("Falha ao encontrar a atividade!");
          }
        })
        .catch(error => {
          if (error.response && error.response.status === 401) {
            this.error("Sua sessão expirou!");
            this.props.logout();
          } else {
            this.error("Falha ao encontrar a atividade!");
          }
        });
    });
  }

  saveTextProduction = pages => {
    let pagesObj = [];
    for (let i = 0; i < pages.length; i++) {
      pagesObj.push({
        number: i,
        content: JSON.stringify(pages[i])
      });
    }

    let obj = {
      user_id: this.props.user.user.id,
      literarte_activity_id: 1,
      pages: pagesObj,
      item_id: this.props.match.params.list_id,
      execution_id: this.state.execution_id,
      start: baseDate(this.state.literarteStart),
      end: baseDate(new Date())
    };

    axios
      .post(`${URL.api}literarte/production_create`, obj, {
        headers: { authorization: `Bearer ${this.props.user.token}` }
      })
      .then(resp => {
        if (resp.data.success) {
          toastr.success("Sucesso", "O texto foi salvo.");
          this.setState({
            textProduction: {
              // eslint-disable-next-line react/no-access-state-in-setstate
              ...this.state.textProduction,
              show: false
            }
          });
        }
      });
  };

  render() {
    const { activity_id: activityId, list_id: listId } =
      this.props.match.params;

    const item = this.state.activity?.items.find(
      item => item.id === parseInt(listId)
    );

    if (this.state.loading) {
      return (
        <div
          className="w-100 d-flex align-items-center justify-content-center"
          style={{ height: "100vh" }}
        >
          <Loading />
        </div>
      );
    }
    if (item.type_id === 12) {
      if (item.item_grade) {
        return (
          <div
            className="w-100 d-flex align-items-center justify-content-center"
            style={{ height: "100vh" }}
          >
            <h2>
              {item.item_grade
                ? `Você tirou a nota ${item.item_grade}`
                : "A correção ainda não está disponível"}
            </h2>
          </div>
        );
      }

      return (
        <ApplicatedTvQuestionList
          activityId={activityId}
          id={item.obj_id}
          history={this.props.history}
          prototype={false}
          currentRoute={this.props.currentRoute}
          execution_id={this.state.execution_id}
          item_id={item.id}
        />
      );
    }
    if (item.type_id === 24) {
      return (
        <div
          className="w-100 d-flex align-items-center justify-content-center"
          style={{ height: "100vh" }}
        >
          <ModalTools
            hideModal
            tool={item.type_id}
            activity={activityId}
            students={[]}
            currentRoute={this.props.currentRoute}
          />
        </div>
      );
    }
    if (item.type_id === 15) {
      return (
        <div
          className="w-100 d-flex align-items-center justify-content-center"
          style={{ height: "100vh" }}
        >
          <ModalTools
            hideModal
            tool={item.type_id}
            activity={activityId}
            students={[]}
            currentRoute={this.props.currentRoute}
          />
        </div>
      );
    }
    if (item.type_id === 16 || item.type_id === 27) {
      // LINK
      axios
        .get(`${URL.api}content/los/singleView/${item.obj_id}`, {
          headers: { authorization: `Bearer ${this.props.user.token}` }
        })
        .then(
          resp => {
            window.open(caminhoDoLo(resp), "_blank");
          },
          () => {
            toastr.error(
              "Falha",
              "Não foi possível abrir o link. Tente novamente!"
            );
          }
        );

      return (
        <div
          className="w-100 d-flex align-items-center justify-content-center"
          style={{ height: "100vh" }}
        >
          <h2>Abrindo o link em outra aba...</h2>
        </div>
      );
    }
    if (item.type_id === 14) {
      // LITERARTE
      if (item.item_grade) {
        return (
          <div
            className="w-100 d-flex align-items-center justify-content-center"
            style={{ height: "100vh" }}
          >
            <h2>
              {item.item_grade
                ? `Você tirou a nota ${item.item_grade}`
                : "A correção ainda não está disponível"}
            </h2>
          </div>
        );
      }
      return (
        <div
          className="w-100 d-flex align-items-center justify-content-center"
          style={{ height: "100vh" }}
        >
          <LiterarteModal
            hideModal
            id={this.state.textProduction.id}
            show={this.state.textProduction.show}
            onClose={() =>
              this.setState(
                {
                  textProduction: {
                    // eslint-disable-next-line react/no-access-state-in-setstate
                    ...this.state.textProduction,
                    show: false
                  }
                },
                () => this.handleActivity()
              )
            }
            title={this.state.contentName}
            value={this.state.textProduction.value}
            onChange={value =>
              this.setState({
                textProduction: {
                  // eslint-disable-next-line react/no-access-state-in-setstate
                  ...this.state.textProduction,
                  value
                }
              })
            }
            saveTextProduction={pages => this.saveTextProduction(pages)}
          />
        </div>
      );
    }
    if (item.type_id === 18) {
      if (item.item_percentage === 100) {
        return (
          <div
            className="w-100 d-flex align-items-center justify-content-center"
            style={{ height: "100vh" }}
          >
            <h2>
              {item.item_grade
                ? `Você tirou a nota ${item.item_grade}`
                : "A correção ainda não está disponível"}
            </h2>
          </div>
        );
      }

      return (
        <div
          className="w-100 d-flex flex-column align-items-center justify-content-center"
          style={{ height: "100vh" }}
        >
          <h2>Upload de arquivos</h2>
          <CButton
            color="primary"
            size="lg"
            onClick={() => this.setState({ uploadModal: true })}
          >
            <i className="fa fa-folder-open mr-2"></i> Abrir
          </CButton>
          {this.state.uploadModal && (
            <UploadModal
              onClose={() =>
                this.setState({ uploadModal: false, loading: true }, () =>
                  this.handleActivity()
                )
              }
              upload_id={item.obj_id}
              activity_id={activityId}
              item_id={item.id}
              execution_id={this.state.execution_id}
            />
          )}
        </div>
      );
    }
    if (item.type_id !== 17) {
      return (
        <div
          className="w-100 d-flex align-items-center justify-content-center"
          style={{ height: "100vh" }}
        >
          <Interface
            aula={item.obj_id}
            atividade={activityId}
            currentRoute={this.props.currentRoute}
            modal={false}
            act_item_id={item.id}
            act_execution_id={this.state.execution_id}
          />
        </div>
      );
    }
    const downloadFile = () => {
      const downloadPath = item.link
        ? item.link.substring(item.link.indexOf("uploads/") + 8)
        : `${item.obj_id === 1 ? "activity" : "repo"}/${item.name}`;

      axios
        .get(`${URL.api}download/${downloadPath}`, {
          headers: { authorization: `Bearer ${this.props.user.token}` },
          responseType: "blob"
        })
        .then(resp => {
          FileDownload(resp.data, item.name);
        });
    };

    return (
      <div
        className="w-100 d-flex flex-column align-items-center justify-content-center"
        style={{ height: "100vh" }}
      >
        <h2>Download de arquivo</h2>
        <CButton color="primary" size="lg" onClick={() => downloadFile()}>
          <i className="fa fa-cloud-download mr-2"></i> Baixar
        </CButton>
        <ProtectedRoute routeId={this.props.currentRoute} />
      </div>
    );
  }
}

EvaluationTv.propTypes = {
  hideLayout: PropTypes.bool,
  guestLogin: PropTypes.bool
};

EvaluationTv.defaultProps = {
  hideLayout: true,
  guestLogin: true
};

const mapStateToProps = state => ({
  user: state.user,
  general: state.general,
  profile: state.profile
});

function mapDispatchToProps(dispatch) {
  return bindActionCreators(
    {
      logout,
      setObj,
      setLayout
    },
    dispatch
  );
}

export default connect(mapStateToProps, mapDispatchToProps)(EvaluationTv);
